import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import Modal from '@bd/bdui-modal';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import ModalContactForm from './ModalContactForm';
import { colors, typography } from '../styles';

const modalStyles = css`
  position: absolute;
  top: 30px;
  width: 580px;
  left: 50%;
  margin-left: -290px;
  height: auto;
  background-image: url('/images/comm-detail-description-bg-fpo.jpg');
  background-size: cover;
  &:after {
    content: '';
    position: absolute;
    z-index: 1;
    display: block;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(63,63,63,.85);
  }
  @media (max-width: 991px) {
    top: 15px;
    left: 15px;
    right: 15px;
    width: auto;
    margin: 0;
  }
  .ContactModal_header {
    background-color: ${colors.color2Dark};
    background-size: 25% auto;
    background-repeat: repeat-y;
    background-position: left top;
    z-index: 2;
    position: relative;
    padding: 50px 30px 30px 30px;
    @media (max-width: 991px) {
      padding: 10px 30px 10px 10px;
      height: 75px;
    }
    img {
      width: 100%;
      height: auto;
      float: left;
      margin: 0 30px 0 0;
      @media (max-width: 991px) {
        display: none;
      }
    }
    .ContactModal_title {
      font-family: ${typography.SansSerif};
      font-size: 36px;
      font-weight: 800;
      color: #FFFFFF;
      line-height: 40px;
      margin: 0;
      @media (max-width: 991px) {
        font-size: 24px;
        line-height: 24px;
        padding-top: 5px;
      }
    }
    .ContactModal_postTitle{
      display: block;
      font-size: 24px;
      color: ${colors.color3};
      @media (max-width: 991px) {
        font-size: 18px;
      }
    }
    p {
      color: #FFFFFF;
    }
    a {
      color: #FFFFFF;
    }
  }
  .ContactModal_body {
    padding: 30px;
    position: relative;
    z-index: 2;
    @media (max-width: 991px) {
      padding: 15px 0;
    }
    .btn {
      background-color: ${colors.color1};
      background-image: none;
      padding: 10px 15px;
    }
  }
  .ContactModal_footer {
    background-color: #000000;
    padding: 20px 30px;
    position: relative;
    z-index: 2;
    display: flex;
    justify-content: space-around;
    align-items: center;
    color: #FFFFFF;
    font-size: 13px;
    font-weight: 800;
    @media (min-width: 992px) {
      display: none;
    }
    a {
      background-color: ${colors.color2};
      color: #FFFFFF;
      padding: 8px 15px;
      font-weight: 800;
      font-size: 13px;
      line-height: 15px;
      display: flex;
      align-items: center;
      width: 120px;
      img {
        margin: 0 10px 0 0;
      }
    }
  }

  .invalid-feedback {
    color: #FFFFFF;
  }

  a.modal-close {
    position: absolute;
    top: 15px;
    right: 15px;
    z-index: 10;
    font-size: 30px;
    line-height: 30px;
    color: #FFFFFF;
  }
`;

const modalOverlayStyles = css`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 101;
  background-color: rgba(0,0,0, 0.3);
  overflow-y: auto;
`;

const formStyles = css``;

class ContactModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal(e) {
    let currentElem = e.target;

    while (currentElem.tagName !== 'A' && currentElem.parentNode !== document) {
      currentElem = currentElem.parentNode;
    }

    if (currentElem.nodeName !== 'A') {
      e.preventDefault();
      this.setState({
        modalIsOpen: true,
      });
    }
  }

  closeModal(e) {
    if (e) {
      e.preventDefault();
    }
    this.setState({ modalIsOpen: false });
  }

  render() {
    const { agent, builder, children, formLabel, formName } = this.props;
    const agentPhotoUrl = get(agent, 'logo.contentUrl');
    return (
      <div>
        <span className="ContactModal_button" role="button" tabIndex={0} onClick={this.openModal}>
          {children}
        </span>
        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          contentLabel="Contact Modal"
          className={modalStyles}
          overlayClassName={modalOverlayStyles}
        >
          <a href className="modal-close" onClick={this.closeModal}>&times;</a>
          <div className="ContactModal_header">
            <div className="container">
              <div className="row">
                {
                  agentPhotoUrl &&
                  <div className="col-md-4">
                    <img
                      src={agentPhotoUrl}
                      alt={`${get(agent, 'name')} - ${get(agent, 'title')}`}
                    />
                  </div>
                }
                <div className="col-md-8">
                  <h2 className="ContactModal_title">
                    Have Questions?
                    <span className="ContactModal_postTitle">We Have Your Answers!</span>
                  </h2>
                  <p>
                    <a href={`tel:${get(builder, 'telephone').replace(/[^0-9]/g, '')}`}>{get(builder, 'phone_number_display')}</a><br />
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="ContactModal_body">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <ModalContactForm
                    className={formStyles}
                    formLabel={formLabel}
                    formName={formName}
                    noRedirect
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="ContactModal_footer">
            <a href={`tel:${get(builder, 'telephone').replace(/[^0-9]/g, '')}`}>
              <img src="/images/icon-phone-white.svg" alt="" />
              Call Now
            </a>
            {/* <div>or</div>
            <a href={`sms:${get(builder, 'text_phone', '').replace(/[^0-9]/g, '')}`}>
              <img src="/images/icon-text-white.svg" alt="" />
              Send<br />Text
            </a> */}
          </div>
        </Modal>
      </div>
    );
  }
}

ContactModal.propTypes = {
  agent: PropTypes.object,
  builder: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  formLabel: PropTypes.string,
  formName: PropTypes.string,
};

ContactModal.defaultProps = {
  formLabel: undefined,
  formName: undefined,
};

ContactModal.defaultProps = {
  agent: undefined,
};

export default withData(
  {
    builder: true,
  },
)(ContactModal);



// WEBPACK FOOTER //
// ./src/components/ContactModal.js